import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getEmpleos,
  deleteEmpleo,
  changeStatusEmpleo,
  changeStatusValidateEmpleo,
} from "../../../../api/empleo";
import {
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditGestionModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";
import FiltersCard from "../../../components/filters/Filter";
import { getLocalidades } from "../../../../api/localidad";
import { getNonEmpty } from "../../../../utils/helpers";
import Select from "react-select";
import { VerifiedUser } from "@material-ui/icons";
import { Verified } from "lucide-react";

function getData(empleos, localidades) {
  let data = [];
  for (let i = 0; i < empleos.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(empleos[i].titulo);
    elem.empresa = empleos[i].empresa || "";
    elem.contacto = empleos[i].contacto || "";
    elem.email = empleos[i].email || "";
    elem.acceso = empleos[i].acceso;
    elem.fecha_publicacion = empleos[i].fecha_publicacion;
    elem.id = empleos[i]._id;
    elem.active = empleos[i].active;
    elem.validate = empleos[i].validate; // Para filtro de validación
    elem._id = empleos[i]._id;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  active: false,
  tipoAcceso: null,
  validado: false,
};

export default function EmpleosPage() {
  const [data, setData] = useState([]);
  const [empleoId, setEmpleoId] = useState(null);
  const [localidades, setLocalidades] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("empleosPageFilters");
    return savedFilters ? JSON.parse(savedFilters) : initialFilters;
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem("empleosPage_searchText");
    return saved || "";
  });
  const history = useHistory();

  // Handler para actualizar la búsqueda (se usa tanto desde el TextField como desde el Table)
  const handleTableSearchChange = useCallback((value) => {
    const trimmedValue = value ? value : "";
    setSearchText(trimmedValue);
    if (trimmedValue) {
      localStorage.setItem("empleosPage_searchText", trimmedValue);
    } else {
      localStorage.removeItem("empleosPage_searchText");
    }
  }, []);
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              // Guardar filtros actuales antes de navegar
              localStorage.setItem(
                "empleosPageFilters",
                JSON.stringify(filterOptions),
              );
              history.push("/edit-empleo/" + cell);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditGestionModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.validate ? "Validado" : "Pendiente"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setEmpleoId(elem);
                  setOpenConfirmDialog(3);
                }}
              >
                {elem?.validate ? (
                  <Verified />
                ) : (
                  <Verified style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setEmpleoId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setEmpleoId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "titulo", text: "Titulo", sort: true },
    { dataField: "empresa", text: "Empresa", sort: true },
    { dataField: "contacto", text: "Contacto", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "acceso", text: "Acceso", sort: true },
    {
      dataField: "fecha_publicacion",
      text: "Fecha publicación",
      sort: true,
      formatter: dateFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const resLocalidad = await getLocalidades();
        if (resLocalidad.status === 200) {
          setLocalidades(resLocalidad.data);
        }
        const res = await getEmpleos();
        if (res.status === 200) {
          setData(res.data);
          // Aplicar filtros guardados si existen
          const savedFilters = localStorage.getItem("empleosPageFilters");
          if (savedFilters) {
            const savedFilterOptions = JSON.parse(savedFilters);
            setFilterOptions(savedFilterOptions);
            // Aplicar filtros automáticamente
            const filtered = res.data.filter((item) => {
              let filter = true;
              if (savedFilterOptions.active) filter = filter && item.active;
              if (savedFilterOptions.tipoAcceso)
                filter =
                  filter && item.acceso === savedFilterOptions.tipoAcceso;
              if (savedFilterOptions.validado) filter = filter && item.validate;
              if (filter) return item;
              return false;
            });
            setFilteredData(filtered);
          } else {
            setFilteredData(res.data);
          }
          setRefresh(false);
        }
      } catch (error) {
        alertError({ error: error, customMessage: "Could not get empleos." });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    // Guardar filtros en localStorage
    localStorage.setItem("empleosPageFilters", JSON.stringify(filterOptions));
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filterOptions.tipoAcceso)
          filter = filter && item.acceso === filterOptions.tipoAcceso;
        if (filterOptions.validado) filter = filter && item.validate;
        if (filter) return item;
        return false;
      }),
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText("");
    localStorage.removeItem("empleosPageFilters");
    localStorage.removeItem("empleosPage_searchText");
    localStorage.removeItem("empleosPage_currentPage");
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "5px 0 0 0" }}>
        {/* Primera fila: Filtros en grid organizado - alineados por abajo */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => handleTableSearchChange(e.target.value)}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Tipo de Acceso
            </label>
            <Select
              value={
                filterOptions.tipoAcceso
                  ? {
                      value: filterOptions.tipoAcceso,
                      label: filterOptions.tipoAcceso,
                    }
                  : null
              }
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  tipoAcceso: selected ? selected.value : null,
                })
              }
              options={[
                { value: "Únicamente socios", label: "Únicamente socios" },
                { value: "Público", label: "Público" },
              ]}
              placeholder="Todos los tipos"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px",
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>
        </div>

        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}
            >
              {/* Switches a la izquierda */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{ gap: "30px" }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.active
                      ? "Solo activos"
                      : "Todos (activos/inactivos)"
                  }
                  style={{ margin: 0 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.validado}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          validado: !filterOptions.validado,
                        })
                      }
                      name="checkValidado"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.validado
                      ? "Solo validados"
                      : "Todos (validados/Pendiente)"
                  }
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a",
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de empleos">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-empleo")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && (
            <Table
              data={getData(filteredData, localidades)}
              columns={columns}
              pageKey="empleosPage"
              searchText={searchText}
              onSearchChange={handleTableSearchChange}
            />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              empleoId?.active ? "disable" : "enable"
            } this empleo?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusEmpleo(empleoId._id, !empleoId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${empleoId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        empleoId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      empleoId?.active ? "disable" : "enable"
                    } empleo.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this empleo?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteEmpleo(empleoId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Empleo removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove empleo.",
                  });
                });
            }}
          />

          <ConfirmDialog
            title={`Are you sure you want to ${
              empleoId?.validate ? "validate" : "invalidate"
            } this empleo?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusValidateEmpleo(empleoId._id, !empleoId?.validate)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        empleoId?.validate ? "Validated!" : "Invalidated!"
                      }`,
                      customMessage: `User type ${
                        empleoId?.validate ? "validated" : "invalidated"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      empleoId?.validate ? "validate" : "invalidate"
                    } empleo.`,
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
